import { renderPage } from "renderPage"
import { ClubPartnerIndexPage } from "./Page"

renderPage({ component: ClubPartnerIndexPage })
